import { baseRequestWithHeaders } from './baseRequest';

export const getSpecialistSuggestions = urlQuery => {
  const url = `/search/ops/suggestions?${urlQuery}`;
  const method = 'GET';
  return baseRequestWithHeaders(url, method, null, null);
};
